import { TechRadarApi, TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar';
import { techRadarData } from './techRadarData';

export class TechRadarClient implements TechRadarApi {
  async load(): Promise<TechRadarLoaderResponse> {
    return techRadarData;
  }
}
